const container = document.querySelector('.vayu_blocks_touch_class .wp-block-vayu-blocks-advance-timeline');
let isDragging = false;
let startX;
let scrollLeft;
if(container){


// Enable drag-to-scroll functionality
container.addEventListener('mousedown', (e) => {
  isDragging = true;
  startX = e.pageX - container.offsetLeft; // Track where the mouse is pressed
  scrollLeft = container.scrollLeft; // Store the current scroll position
});

container.addEventListener('mouseleave', () => {
  isDragging = false;
});

container.addEventListener('mouseup', () => {
  isDragging = false;
});

container.addEventListener('mousemove', (e) => {
  if (!isDragging) return; // If not dragging, do nothing
  e.preventDefault(); // Prevent default dragging behavior
  const x = e.pageX - container.offsetLeft; // Calculate new position
  const scroll = (x - startX); // Calculate how far the mouse has moved
  container.scrollLeft = scrollLeft - scroll; // Adjust scroll position accordingly
});

// Optional: Make sure touch devices can also drag-to-scroll
container.addEventListener('touchstart', (e) => {
  isDragging = true;
  startX = e.touches[0].pageX - container.offsetLeft;
  scrollLeft = container.scrollLeft;

});

container.addEventListener('touchend', () => {
  isDragging = false;

});

container.addEventListener('touchmove', (e) => {
  if (!isDragging) return;
  e.preventDefault();
  const x = e.touches[0].pageX - container.offsetLeft;
  const scroll = (x - startX);
  container.scrollLeft = scrollLeft - scroll;
});

}